import { render, staticRenderFns } from "./categoryFilter.vue?vue&type=template&id=33b62944&scoped=true&"
import script from "./categoryFilter.vue?vue&type=script&lang=js&"
export * from "./categoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./categoryFilter.vue?vue&type=style&index=0&id=33b62944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b62944",
  null
  
)

export default component.exports